import type { UserPreference } from "~/types/User";

export const usePreferenceApiService = function() {
  const client = useSanctumClient();
  return {
    getPreference: async (userId: string) => {
      return await client(buildUrl(preferenceUrl.getById, { id: userId }));
    },
    update: async (newPreference: UserPreference) => {
      return await client(preferenceUrl.update, {
        method: "post",
        body: newPreference,
      });
    },
  };
};
